<script lang="ts">
	import BrandMark from './BrandMark.svelte';
	import Icon from './Icon.svelte';
</script>

<footer class="site-footer">
	<div class="page footer-grid">
		<div class="footer-brand">
			<a class="brand" href="/" aria-label="ANDRESOT — на главную">
				<BrandMark size={40} decorative /><span class="brand-word">ANDRESOT</span>
			</a>
			<p>Для разговоров, идей и всего, чем хочется поделиться.</p>
		</div>
		<div class="footer-column">
			<strong>Продукт</strong>
			<a href="/#product">Возможности</a>
			<a href="/#technology">Приватность</a>
			<a href="/download/">Установка</a>
		</div>
		<div class="footer-column">
			<strong>Поддержка</strong>
			<a href="mailto:support@andresot.ru">support@andresot.ru</a>
			<a href="https://web.andresot.ru/help">Справка</a>
			<a href="https://web.andresot.ru">Веб-приложение <Icon name="external" size={14} /></a>
		</div>
		<div class="footer-column">
			<strong>Правовая информация</strong>
			<a href="https://web.andresot.ru/legal/terms">Пользовательское соглашение</a>
			<a href="https://web.andresot.ru/legal/privacy">Политика конфиденциальности</a>
		</div>
	</div>
	<div class="page footer-bottom">
		<span>© 2026 ANDRESOT</span>
		<span>Чаты, звонки, файлы и почта</span>
	</div>
</footer>
